import React, { useEffect } from "react";
import Header from "../../../layout/Header";
import Footer from "../../../layout/Footer";
import HeroSection from "../../../layout/HeroSection";
import Listing from "../../lessons/Listing";
import { pageRoutes } from "../../../routes/pageRoutes";
import Loader from "../../../components/other/Loader";
import { fetchBeetleweight } from "../../../redux/action/weightAction";
import { useDispatch, useSelector } from "react-redux";

const Beetleweights = () => {
  const dispatch = useDispatch();
  const { beetleweightsList, isLoading } = useSelector(
    (state) => state?.weightReducer
  );
 
  useEffect(() => {
    dispatch(fetchBeetleweight());
  }, []);


  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <div>
        <Header />
        <HeroSection
          label={<h1 class="mb-3">{"Beetleweights"}</h1>}
          breadcrumbItems={[
            { name: "Home", path: `${pageRoutes?.home}/` },
            {
              name: "Beetleweights",
              path: `${pageRoutes?.home}/`,
            },
          ]}
        />

        <Listing contentData={beetleweightsList} />

        <Footer />
      </div>
    </>
  );
};

export default Beetleweights;
